import { useMutation, useQueryClient } from '@tanstack/react-query';
import { toast } from 'react-toastify';

import { TSDSendPresentationNotificationData } from '@e-origin/contracts';

import { showErrorToast } from '@hooks/showErrorToast';
import { apiClient } from '@utils';

export const useSendPresentationNotification = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (data: TSDSendPresentationNotificationData) => {
      const result = await apiClient.tsd.sendPresentationNotification.mutation({ body: data });
      if (result.status !== 200) throw result.body;
      return result.body.data;
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['temporary-storages'] });
      toast.success('Temporary storage declaration sent successfully!');
    },
    onError: (error) => {
      queryClient.invalidateQueries({ queryKey: ['temporary-storages'] });
      showErrorToast(error, `Error sending the temporary storage declaration!`);
    },
  });
};
